import ContentPageTemplate from '@/components/ContentPageTemplate';
import { marketingPages } from '@/data/marketingPages';

export default function OurFeesPage() {
  return <ContentPageTemplate page={marketingPages['our-fees']} />;
}
